import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AuthProvider from "./components/AuthProvider";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import ReactHotToast from "./styles/lib/react-hot-toast";
import { Toaster } from "react-hot-toast";
import ThemeWrapper from "@components/theme/mui";
import { apiClient } from "@api/index";

const AuthenticatedApp = withAuthenticationRequired(App);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeWrapper>
          <apiClient.Provider queryClient={queryClient as any}>
            <ReactHotToast>
              <Toaster
                position={"bottom-right"}
                toastOptions={{ className: "react-hot-toast" }}
              />
            </ReactHotToast>
            <AuthenticatedApp />
          </apiClient.Provider>
        </ThemeWrapper>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);
